var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenLocationMarker(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 42,
    viewBox: "0 0 35 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2542_15693)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5108 32.7835C16.5593 32.8116 16.5974 32.8333 16.6244 32.8485L16.6693 32.8735C17.0272 33.07 17.4712 33.0685 17.8295 32.8741L17.8756 32.8485C17.9026 32.8333 17.9407 32.8116 17.9892 32.7835C18.0862 32.7273 18.2248 32.6453 18.3991 32.538C18.7476 32.3234 19.2395 32.007 19.8271 31.5919C21.0003 30.7631 22.5657 29.5335 24.1345 27.9272C27.2568 24.7304 30.5 19.9272 30.5 13.75C30.5 6.43223 24.5678 0.5 17.25 0.5C9.93223 0.5 4 6.43223 4 13.75C4 19.9272 7.24316 24.7304 10.3656 27.9272C11.9343 29.5335 13.4997 30.7631 14.6729 31.5919C15.2605 32.007 15.7524 32.3234 16.1009 32.538C16.2752 32.6453 16.4138 32.7273 16.5108 32.7835ZM17.25 18.5682C19.911 18.5682 22.0682 16.411 22.0682 13.75C22.0682 11.089 19.911 8.93182 17.25 8.93182C14.589 8.93182 12.4318 11.089 12.4318 13.75C12.4318 16.411 14.589 18.5682 17.25 18.5682Z",
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("text", {
    x: 17.25,
    y: 13.2,
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#fff",
    fontFamily: "Arial,sans-serif",
    fontSize: 12,
    fontWeight: 900
  }, "E"))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2542_15693",
    x: 0,
    y: 0.5,
    width: 34.5,
    height: 40.5205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2542_15693"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2542_15693",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLocationMarker);
export default __webpack_public_path__ + "static/media/green-location-marker.8f39d081bbc83dccaf4af8246f927b2c.svg";
export { ForwardRef as ReactComponent };